var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28469 3.2H15.0014C16.6582 3.2 18 4.54314 18 6.2V11.2084L17.4931 10.7578C16.3564 9.74741 14.6436 9.74741 13.5069 10.7578L12.0069 12.0911C10.873 13.099 10.6838 14.7739 11.5051 16H3C1.34315 16 0 14.6569 0 13V2.56692C0 1.14925 1.14925 0 2.56692 0H5.11436C5.83286 0 6.93622 1.17792 7.76245 2.05999C8.06138 2.37912 8.32403 2.65952 8.51906 2.8314C8.65858 2.95435 9.09872 3.2 9.28469 3.2Z",
    fill: "#0F973D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1644 12.2526C15.7855 11.9158 15.2145 11.9158 14.8356 12.2526L13.3356 13.5859C12.9229 13.9528 12.8857 14.5849 13.2526 14.9977C13.5736 15.3588 14.0975 15.4325 14.5 15.1996V18C14.5 18.5523 14.9477 19 15.5 19C16.0523 19 16.5 18.5523 16.5 18V15.1996C16.9025 15.4325 17.4264 15.3588 17.7474 14.9977C18.1143 14.5849 18.0771 13.9528 17.6644 13.5859L16.1644 12.2526Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep1);
export default __webpack_public_path__ + "static/media/ic_step1.ff102b2d5afce472223e1f2340a6cdb1.svg";
export { ForwardRef as ReactComponent };